




























































































































































































































import { Component, Vue, Watch } from "@/shared/vuepack";
import * as _ from "lodash";
import {
  CardProvider,
  CommunicationDeliveryType,
  CommunicationDeliveryTypeMap,
  ContactInformation,
  EmployerEmployeeProfileSettingValue,
  FetchState,
  NotificationPreference,
  NotificationPreferenceCategory,
  NotificationPreferenceCategoryConfig,
  NotificationPreferenceTypeConfig,
  Preference,
  PreferenceConfiguration,
} from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import SettingsNavigation from "@/employee/components/settings/SettingsNavigation.vue";
import SettingsHeader from "@/employee/components/settings/SettingsHeader.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { useContactInfoStore } from "@/shared/store/contactinfo";
import { useThemeStore } from "@/shared/store/theme";
import { useNotificationPreferencesStore } from "@/shared/store/notificationPreferences";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useNotifierStore } from "@/shared/store/notifier";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useCardProviderOptionsStore } from "@/employee/store/cardProviderOptions";
import EditProfile from "@/employee/components/settings/profile/EditProfile.vue";
import StatefulLabel from "@/shared/components/ui/StatefulLabel.vue";

const initialState: ContactInformation = {
  firstName: "",
  middleInitial: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  isMailingSameAsPhysical: false,
  dateOfBirth: "",
  mailingAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  physicalAddress: {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: ""
  },
  lastFourSsn: "",
  memberNumber: "",
  lastLogin: "",
  username: ""
};

const editProfileDisabledMessage = "Editing has been disabled by your employer. Please contact your employer directly to make changes.";

@Component({
  computed: {
  },
  components: {
    SettingsNavigation,
    SettingsHeader,
    GenericLoadingSpinner,
    StatefulLabel,
    EditProfile,
  }
})
export default class UserNotificationSettings extends Vue {
  RouteNames = RouteNames;
  notificationPreferencesStore = useNotificationPreferencesStore();
  themeStore = useThemeStore();
  contactInfoStore = useContactInfoStore();
  featureFlagStore = useFeatureFlagStore();
  notifierStore = useNotifierStore();
  formModel: ContactInformation = {...initialState};
  updatedPreferences: NotificationPreference[] = [];
  communicationDeliveryTypeMap = new Map<string, Map<string, boolean>>();
  isOptedIntoPaper = false;
  debounceSaveNotificationPreferences = _.debounce(this.saveNotificationPreferences, 1000);
  disablePaperlessToggle = false;
  custodianSettingsStore = useCustodianSettingsStore();
  editProfileDisabledMessage = editProfileDisabledMessage;
  cardProviderOptionsStore = useCardProviderOptionsStore();
  shouldHideDebitCardCategory = false;
  editProfileParameters = {
    show: {value: false},
    contactInfo: {...initialState},
    onSave: this.onSaveProfile,
    toggleClose: this.closeEditProfileForm
  };

  mounted () {
    this.contactInfoStore.getContactInformation();
    this.initializeFromStateValue();
    this.cardProviderOptionsStore.getCardProviderOptions().catch(error => {
      this.shouldHideDebitCardCategory = true;
    });
    this.notificationPreferencesStore.getNotificationPreferences();
  }

  @Watch("isDataForNotificationPreferencesLoaded", {immediate: true})
  onDataForNotificationPreferencesLoaded () {
    if (this.notificationPreferencesStore.notificationPreferencesLoaded && this.cardProviderOptionsStore.isLoaded) {
      this.shouldHideDebitCardCategory = this.cardProviderOptionsStore.cardProvider === CardProvider.Fiserv;
      this.initializePreferenceState();
    }
  }

  @Watch("notificationPreferencesStore.hasSavedNotificationPreferences", {immediate: true})
  onHasSavedNotificationPreferences () {
    if (this.notificationPreferencesStore.hasSavedNotificationPreferences) {
      this.initializePreferenceState();
      this.disablePaperlessToggle = false;
    }
  }

  get isDataForNotificationPreferencesLoaded (): boolean {
    return this.isNotificationPreferencesLoaded && this.cardProviderOptionsStore.isLoaded;
  }

  initializePreferenceState () {
    if (this.shouldHideDebitCardCategory) {
      this.hideDebitCardCategory();
    }

    this.createPreferenceMaps();
    this.isOptedIntoPaper = this.notificationPreferencesStore.HasAnyPaperPreferencesOn;
  }

  hideDebitCardCategory = () => {
    this.notificationPreferencesStore.notificationPreferences = this.notificationPreferencesStore.notificationPreferences
        .filter(x => x.category !== NotificationPreferenceCategory.DebitCards);
  }

  get isLoaded () {
    return this.contactInfoStore.contactInformationState === FetchState.Loaded;
  }

  isStringNullOrEmpty (str) {
    return str === undefined || str === null || str === "";
  }

  get hasMobilePhoneNumber () {
    return !this.isStringNullOrEmpty(this.formModel.mobilePhoneNumber);
  }

  get isNotificationPreferencesLoaded () {
    return this.notificationPreferencesStore.notificationPreferencesLoaded;
  }

  get isNotificationPreferencesLoading () {
    return this.notificationPreferencesStore.notificationPreferencesLoading;
  }

  get showNotificationPreferences () {
    return this.isDataForNotificationPreferencesLoaded &&
        this.notificationPreferencesStore.notificationPreferences.length > 0 &&
        !this.notificationPreferencesStore.isSavingPreferences;
  }

  get showLoadingSpinner () {
    return this.isNotificationPreferencesLoading || this.notificationPreferencesStore.isSavingPreferences;
  }

  get notificationPreferences (): NotificationPreference[] | [] {
    return this.notificationPreferencesStore.notificationPreferences;
  }

  onTogglePaperlessCommunications () {
    if (this.isOptedIntoPaper === true) {
      this.disablePaperlessToggle = true;
      this.enrollInPaperlessNotificationPreferences();
      this.saveNotificationPreferences();
    }
  }

  enrollInPaperlessNotificationPreferences () {
    this.debounceSaveNotificationPreferences.cancel();
    this.notificationPreferencesStore.savePaperlessNotificationPreferences();
    this.createPreferenceMaps();
  }

  getThresholdTitle (preference: Preference, communicationDeliveryTypeKey: string): string {
    if (this.showToggleTooltip(preference, communicationDeliveryTypeKey) &&
        this.isCommunicationDeliveryTypeDisabled(preference, communicationDeliveryTypeKey)) {
      return "Amount required in order to enable this notification.";
    }
    return "";
  }

  showToggleTooltip (preference: Preference, communicationDeliveryTypeKey: string): boolean {
    if (preference.threshold) {
      return communicationDeliveryTypeKey === CommunicationDeliveryType.Sms ||
          communicationDeliveryTypeKey === CommunicationDeliveryType.Email;
    }
    return false;
  }

  onToggleConfiguration (notification: NotificationPreference, preference: Preference, communicationDeliveryTypeKey: string, newValue: boolean) {
    if (!notification && !preference) {
      return;
    }
    const config = this.getConfig(preference.configurations, communicationDeliveryTypeKey);
    if (!config) {
      return;
    }
    config.optedIn = newValue;

    this.debounceSaveNotificationPreferences();
  }

  getConfig (configurations: PreferenceConfiguration[], communicationDeliveryType: string): PreferenceConfiguration | null {
    if (configurations && configurations.length > 0) {
      if (!this.hasMobilePhoneNumber && communicationDeliveryType === CommunicationDeliveryType.Sms) {
        return null;
      }
      return configurations.find(c => c.communicationDeliveryType === communicationDeliveryType);
    }
    return null;
  }

  get filteredCommunicationDeliveryTypes () {
    const entries = Object.entries(CommunicationDeliveryTypeMap);

    if (!this.hasMobilePhoneNumber && entries.length > 0) {
      return entries.filter(([key]) => key !== CommunicationDeliveryType.Sms);
    }
    return entries;
  }

  createPreferenceMaps () {
    this.communicationDeliveryTypeMap.clear();
    for (const notificationPreference of this.notificationPreferencesStore.notificationPreferences) {
      for (const preference of notificationPreference.preferences) {
        const key = this.preferenceKey(notificationPreference.category, preference.notificationPreferenceType);
        const deliveryTypeMap = new Map<string, boolean>();
        for (const config of preference.configurations) {
          deliveryTypeMap.set(config.communicationDeliveryType, config.optedIn);
        }
        this.communicationDeliveryTypeMap.set(key, deliveryTypeMap);
      }
    }
  }

  preferenceKey (category: string, notificationPreferenceType: string) {
    return `${category}::${notificationPreferenceType}`;
  }

  async saveNotificationPreferences () {
    await this.notificationPreferencesStore.saveNotificationPreferences();
    this.createPreferenceMaps();
  }

  cloneToCurrentModel (o) {
    return _.cloneDeep(o);
  }

  isThresholdDisabled (preference: Preference): boolean {
    const smsDeliveryType = preference.configurations.find(x => x.communicationDeliveryType === CommunicationDeliveryType.Sms);
    const emailDeliveryType = preference.configurations.find(x => x.communicationDeliveryType === CommunicationDeliveryType.Email);
    return !smsDeliveryType.enabled && !emailDeliveryType.enabled;
  }

  get thresholdAmountValidator () {
    return {
      required: true,
      decimal: 2,
      min_value_usd: 0.01,
    };
  }

  hasThresholdOption (preference: Preference): boolean {
    return this.notificationPreferencesStore.hasThresholdOption(preference);
  }

  isCommunicationDeliveryTypeDisabled (preference: Preference, communicationDeliveryType: string): boolean {
    const config = this.getConfig(preference.configurations, communicationDeliveryType);
    if (!config.enabled) {
      return true;
    }

    if (config.communicationDeliveryType === CommunicationDeliveryType.Sms && !this.hasMobilePhoneNumber) {
      return true;
    }

    return (config.communicationDeliveryType === CommunicationDeliveryType.Sms ||
            config.communicationDeliveryType === CommunicationDeliveryType.Email) &&
        this.notificationPreferencesStore.hasThresholdOption(preference) && (preference.threshold.value <= 0 || !preference.threshold);
  }

  isCommunicationDeliveryTypeOptedInByDefault (preference: Preference, communicationDeliveryType: string): boolean {
    const config = this.getConfig(preference.configurations, communicationDeliveryType);
    return config.enabled === false && config.optedIn;
  }

  onThresholdChanged (preference: Preference) {
    const hasPaperlessCommunications = preference.configurations
        .some(x => x.communicationDeliveryType === CommunicationDeliveryType.Email && x.optedIn === true
            || (x.communicationDeliveryType === CommunicationDeliveryType.Sms && x.optedIn === true));
    if (hasPaperlessCommunications && preference.threshold && preference.threshold.value > 0) {
      this.debounceSaveNotificationPreferences();
    }
  }

  getThresholdValidationField (category: string, prefName: string, index: number) {
    return `${category}-${prefName}-${index}`;
  }

  getThresholdValidationRules (preference: Preference) {
    if (!this.notificationPreferencesStore.hasThresholdOption(preference) || this.isThresholdDisabled(preference)) {
      return "";
    } else {
      return this.thresholdAmountValidator;
    }
  }

  getNotificationPreferenceDisplayName (preference: Preference): string {
    return (
        NotificationPreferenceTypeConfig[preference.notificationPreferenceType]?.name ?? preference.name
    );
  }

  getCategoryDisplayName (notificationPreference: NotificationPreference) {
    return (
        NotificationPreferenceCategoryConfig[notificationPreference.category]?.categoryDescription ?? notificationPreference.categoryDescription
    );
  }

  getNotificationPreferencesInfoVerbiage (preference: Preference): string {
    return (
        NotificationPreferenceTypeConfig[preference.notificationPreferenceType]?.info ?? ""
    );
  }

  @Watch("contactInfoStore.contactInformationState")
  initializeFromStateValue () {
    const contactInformation = this.contactInfoStore.contactInformation;
    if (this.contactInfoStore.contactInformationState === FetchState.Loaded && !contactInformation) {
      this.formModel = this.cloneToCurrentModel(initialState);
    } else if (contactInformation) {
      this.formModel = this.cloneToCurrentModel(contactInformation);
    }
  }

  @Watch("contactInfoStore.contactInformation")
  onPlanStateChanged () {
    this.initializeFromStateValue();
  }
  get showUndeliverableAddressWarning () {
    return this.formModel.mailingAddress.isUndeliverable === true;
  }
  get privacyUrl () {
    return "https://hsabank.com/HSABank/About/Security/Privacy-and-Opt-Out-Notice";
  }

  get profileEditSettings () {
    if (!this.fieldEditSettings) {
      return [];
    }

    return [
      this.fieldEditSettings.emailAddress,
      this.fieldEditSettings.homePhone,
      this.fieldEditSettings.mailingAddress,
      this.fieldEditSettings.maritalStatus,
      this.fieldEditSettings.mobileNumber
    ];
  }


  get fieldEditSettings () {
    return this.contactInfoStore.contactInformation.fieldEditSettings;
  }

  get editProfileDisabled () {
    return !this.profileEditSettings.some(value => value === EmployerEmployeeProfileSettingValue.Edit);
  }

  async onSaveProfile () {
    return this.contactInfoStore.saveProfile(this.editProfileParameters.contactInfo)
        .then(() => {
          this.editProfileParameters.show.value = false;
        }).catch(() => {/*no operation, handled in store*/
        });
  }

  closeEditProfileForm () {
    this.editProfileParameters.show.value = false;
  }

  onEditProfileClicked () {
    this.editProfileParameters.contactInfo = _.cloneDeep(this.formModel);
    this.editProfileParameters.show.value = true;
  }
}
